import { useState, useEffect, useCallback } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import './index.css';
import './site.css';

import Preloader from './components/Preloader';
import AlertBanner from './components/AlertBanner';
import Header from './components/Header';
import MobileMenu from './components/MobileMenu';
import HomePage from './components/HomePage';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import TicketsPage from './components/TicketsPage';

gsap.registerPlugin(ScrollTrigger);

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/tickets" element={<TicketsPage />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="*" element={<HomePage />} />
    </Routes>
  );
}

export default function App() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  
  const [preloaderDone, setPreloaderDone] = useState(false);
  const [reducedMotion] = useState(
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );

  useEffect(() => {
    if (reducedMotion) {
      document.body.classList.add('preloader-finished');
      document.body.style.overflow = '';
      setPreloaderDone(true);
    }
  }, [reducedMotion]);

  const handlePreloaderComplete = useCallback(() => {
    document.body.classList.add('preloader-finished');
    document.body.style.overflow = '';
    setPreloaderDone(true);
    setTimeout(() => ScrollTrigger.refresh(), 200);
  }, []);

  if (isAdmin) {
    return <AppRoutes />;
  }

  return (
    <>
      {!preloaderDone && !reducedMotion && (
        <Preloader onComplete={handlePreloaderComplete} />
      )}
      <AlertBanner />
      <Header />
      <MobileMenu />
      <div className="page">
        <div className="page-inner">
          <AppRoutes />
        </div>
      </div>
    </>
  );
}
